import { render, staticRenderFns } from "./TenderTimeLeft.vue?vue&type=template&id=c3748728"
import script from "./TenderTimeLeft.vue?vue&type=script&lang=js"
export * from "./TenderTimeLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports